"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FETCH_SUPPLIERS = 'fetch-suppliers';
exports.SELECTED_SUPPLIER = 'selected-supplier';
exports.SELECTED_SUPPLIER_ID = 'selected-supplier-id';
exports.ALL_SUPPLIERS = 'all-suppliers';
exports.SUPPLIER_COUNTRY_LIST = 'supplier-country-list';
exports.CHECK_OFFERTA = 'check-offerta';
